module.exports = __webpack_public_path__ + "img/logo.276c240e.png";